exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-item[data-v-5e34b05d]:not(.disabled) {\n  cursor: pointer;\n}\n.page-item.active a.page-link[data-v-5e34b05d] {\n  z-index: initial;\n}\n.page-item.active a.page-link[data-v-5e34b05d]:hover {\n  color: white;\n}\n", ""]);

// exports
